export const STANDARD_PLAN = 0;
export const PRO_PLAN = 1;
export const PRO_PLUS_PLAN = 2;

export const FLEET_PLANS = {
  standard: STANDARD_PLAN,
  pro: PRO_PLAN,
  pro_plus: PRO_PLUS_PLAN,
};

export enum FleetPlans {
  STANDARD_PLAN,
  PRO_PLAN,
  PRO_PLUS_PLAN,
}
